import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Self-registration is disabled: voters sign in with Microsoft SSO instead.
// Route kept so old bookmarks don't 404 — just redirects to /login.
export default function Register() {
    const navigate = useNavigate();
    useEffect(() => {
        navigate("/login", { replace: true });
    }, [navigate]);
    return null;
}
